<template>
  <div>
    <div class="seat_layout_container" v-if="!loading">
      <div class="section-seatlayout section-eventseatlayout">
        <div class="seat-layout-nav">
          <nav class="seat-nav w-100">
            <!-- <ul class="seat-appearance-list event-seat-list">
              <li
                v-for="(price, index) in prices"
                :key="index"
                :class="index == 1 ? 'blue' : index == 2 ? 'purple' : 'orange'"
              >
                {{ price.price }} {{ price.currency }}
              </li>
            </ul> -->
            <ul class="seat-appearance-list event-seat-list">
              <li v-for="(data, aindex) in wholeData" :key="aindex">
                <span
                  class="color-circle"
                  :style="{
                    backgroundColor: color[aindex]
                  }"
                ></span>
                <!-- {{ title }}  -->
                {{ data.seat_type[0].price }} {{ data.seat_type[0].currency }}
              </li>

              <li v-on:click="reset">
                <span
                  class="color-circle"
                  :style="{
                    backgroundColor: color[aindex]
                  }"
                ></span>
                Reset
              </li>
            </ul>
          </nav>
        </div>
        <div class="panzoom" id="panzoom-element">
          <!-- <div class="selectMove"> -->
          <div class="seat-selection">
            <div
              v-for="(seatArea, aindex) in seatJson"
              :key="aindex"
              :id="'area' + aindex"
            >
              <div v-if="seatArea.name == 'stage'" class="seat-stage">
                <!-- <img src="@/assets/img/screen-blue.png" class="screen-img"/> -->
                <div class="seat-area-desc">STAGE</div>
              </div>

              <div
                class="seat-area"
                v-on:click="
                  e => {
                    areaclicked(e, aindex);
                  }
                "
                :id="'areac' + aindex"
                v-if="seatArea.name == 'area'"
                :style="{
                  height: `${15 + seatArea.rows.length * 35}px`,
                  position: absolute,
                  width: `${maxSeat * 25}px`,
                  left: `${seatArea.rows[0][0].ax}px`
                }"
              >
                <div class="seat-area-desc">
                  {{ seatArea.title }}
                </div>
                <div class="seat-area-desc1">
                  {{ seatArea.title }}
                </div>
                <div
                  class="seat-area-rows"
                  v-for="(seatRow, rindex) in seatArea.rows"
                  :key="rindex"
                  :style="{
                    top: `${Math.abs(seatArea.rows[0][0].py) +
                      parseFloat(seatRow[0].py) +
                      25}px`,
                    left: seatRow[0].pxx1 + 'px'
                  }"
                >
                  <div
                    v-for="(seat, sindex) in seatRow"
                    :key="sindex"
                    :class="
                      seat.status == 1 && seat && seat.selected
                        ? 'seat-row-seat seat-selected'
                        : seat.status == 2
                        ? 'seat-row-seat seat-blocked'
                        : seat.status == 3
                        ? 'seat-row-seat seat-booked'
                        : 'seat-row-seat'
                    "
                    :style="{
                      top: `${parseInt(seat.top)}px`,
                      left: `${pxn + parseInt(seat.left)}px`
                    }"
                    v-on:click="seatclicked(aindex, rindex, sindex)"
                  >
                    {{ seat.name }}
                    <!-- {{ `${seat.selected}` }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-md-block">
      <section class="detailHeader">
        <div class="detailHeader-content">
          <div>
            <router-link @click.native="$router.go(-1)" to>
              <img
                src="@/assets/img/icons/chevron-left.svg"
                height="18px"
                width="18px"
              />
            </router-link>
          </div>
          <div class="header-content">
            <div>{{ showtitle }}</div>
            <div>{{ showdatetime }}</div>
          </div>
        </div>
        <div class="no-tickets-header" v-b-modal.seat_select_modal>
          <span>1 Tickets</span>
          <span>
            <img
              src="@/assets/img/icons/chevron-left.svg"
              height="18px"
              width="18px"
              class="icon"
            />
          </span>
        </div>
      </section>
      <div class="spacing"></div>

      <section class="detailFooter" v-if="showModal">
        <div class="detailFooter-content">
          <div>
            <div class="flex-1">
              <div>{{ noofticket }}</div>
              <div class="primary-color">{{ total }}</div>
            </div>
            <div class="flex-1">
              <div>Seats Selected</div>
              <div>
                <ul class="list-inline seats-selected mb-0">
                  <span class="list-inline-item primary-color">{{
                    seatsSelected
                  }}</span>
                </ul>
              </div>
            </div>
          </div>
          <div class="navProceed">
            <!-- <router-link to="#" class="font-weight-bold text-white"
              >{{ $t("PROCEED") }} TO PAY</router-link
            > -->
            <button
              class="btn btn-pink event-btn-proceed"
              @click="routePaymentPage()"
            >
              BOOK
            </button>
          </div>
        </div>
      </section>
      <div class="select-seat-modal">
        <!-- <b-button v-b-modal.seat_select_modal>Select Seat</b-button> -->
        <b-modal
          hide-footer
          hide-header
          ref="seat_select_modal"
          id="seat_select_modal"
          class="seat_select_modal"
        >
          <div class="seats_num py-2 text-center">
            <h5>
              {{ $t("SELECT_NO_OF_SEAT") }}
            </h5>
            <div class="my-4">
              <div v-for="(data, index) in 6" :key="index">
                <!-- <img src="@/assets/img/seats/1Seats.png" class="about_img"/> -->
                <div v-if="totalNumberOfSeats == index + 1">
                  <img
                    :src="
                      require('@/assets/img/seats/' + (index + 1) + 'Seats.png')
                    "
                    alt=""
                    class="numbers-seats-img"
                  />
                </div>
              </div>
            </div>
            <!-- <ul
              class="seatNumList list-inline pl-0 mb-0"
              :class="isRTL ? 'number_reverse' : ''"
            >
              <li
                class="list-inline-item seat_btn"
                v-for="(item, itemKey) in 6"
                :key="itemKey"
                :class="
                  totalNumberOfSeats == item ? 'seat_btn_active active' : ''
                "
                @click="onShowSeatImg(item)"
              >
                {{ itemKey + 1 }}
              </li>
            </ul> -->
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { isMobile, isIOS, isAndroid } from "mobile-device-detect";
import { makeRequest } from "@/helper/internet.js";
import { EVENT_URL } from "@/helper/constant.js";
import { LanguageService, CountryService } from "@/services/storage.service";
export default {
  data() {
    return {
      pxn: 0,
      counter: 0,
      url: EVENT_URL,
      loading: true,
      totalNumberOfSeats: 0,
      showModal: false,
      panzoom: null,
      maxSeat: 20,
      color: ["#c32a2a", "#D4AF37", "#C0C0C0"],
      int1: null,
      selectedSeatID: [1],
      seatJson: [],
      scale: 0,
      seatsSelectedObj: [],
      seatsSelected: "",
      prices: [],
      seatTitles: [],
      wholeData: [],
      showdatetime: "",
      showtitle: "",
      seat_details: [],
      selectedCatID: "",
      indexs: [],
      resetx: 0,
      resety: 0,
      seatClassName: "seat-row-seat"
    };
  },
  methods: {
    seatclicked(aindex, rindex, sindex, seat) {
      if (this.seatJson[aindex].rows[rindex][sindex].status == 1) {
        this.seatJson[aindex].rows[rindex][sindex].selected = !this.seatJson[
          aindex
        ].rows[rindex][sindex].selected;
        let seat = this.seatJson[aindex].rows[rindex][sindex];

        if (this.seatJson[aindex].rows[rindex][sindex].selected) {
          if (this.selectedCatID == "") {
            this.selectedCatID = this.seatJson[aindex].title;
          }

          if (this.selectedCatID != this.seatJson[aindex].title) {
            let seats = this.seatsSelectedObj[this.selectedCatID];
            let seatKeys = Object.keys(seats);
            seatKeys.map(s => {
              if (seats[s].selected) {
                seats[s].selected = false;
              }
            });

            this.indexs.map(s => {
              this.seatJson[s[0]].rows[s[1]][s[2]].selected = false;
            });
            this.indexs = [[aindex, rindex, sindex]];
            this.selectedCatID = this.seatJson[aindex].title;
            // console.log("Update.selectedCatID :>> ", this.selectedCatID);
          } else {
            this.indexs.push([aindex, rindex, sindex]);

            // console.log("common :>> ");
          }
        }
        if (this.seatsSelectedObj[this.seatJson[aindex].title]) {
          // this.seatsSelectedObj[this.seatJson[aindex].name] = [];
          this.seatsSelectedObj[this.seatJson[aindex].title][seat.name] = {
            ...seat,
            seat_type: this.seatJson[aindex].seat_type
          };
        } else {
          this.seatsSelectedObj[this.seatJson[aindex].title] = [];
          this.seatsSelectedObj[this.seatJson[aindex].title][seat.name] = {
            ...seat,
            seat_type: this.seatJson[aindex].seat_type
          };
        }

        console.log("seatsSelectedObj :>> ", this.seatsSelectedObj);

        let areaKeys = Object.keys(this.seatsSelectedObj);
        let show = false;
        let that = this;
        let temp = "";
        let temp2 = "";
        let temp3 = 0;
        let temp4 = [];
        let temp5 = [];
        areaKeys.map(d => {
          let seats = this.seatsSelectedObj[d];
          let seatKeys = Object.keys(seats);
          let count = 0;
          let price = 0;
          let currency = "";
          let s1 = "";
          let seat_type_id = 0;
          seatKeys.map(s => {
            if (seats[s].selected) {
              count++;
              show = true;
              if (s1 != "") {
                s1 += ", " + s;
              } else {
                s1 += " " + s;
              }
              // console.log("object :>> ", object);
              price = seats[s].seat_type[0].price;
              currency = seats[s].seat_type[0].currency;
              seat_type_id = seats[s].seat_type[0].seat_type_id;
              temp5.push({
                seat_id: seats[s].seat_id,
                seat_type_id: seats[s].seat_type[0].seat_type_id
              });
            }
          });

          if (s1 != "") {
            temp += `${d}: ${s1} `;
          }
          if (count > 0) {
            temp4.push({ no_of_seat: count, seat_type_id });
            temp2 += ` ${count} Tickets x ${currency} ${price}`;
            temp3 += count * price;
          }
        });
        if (!show) {
          this.selectedCatID = "";
          this.indexs = [];
        }
        this.seat_details = temp5;
        that.seatsSelected = temp;
        this.noofticket = temp2;
        this.showModal = show;
        // console.log("seat :>> ", seat, this.seatsSelectedObj);

        this.total = temp3;
      }
    },
    selectSeat(areaname, seatname, price, currency, clicked) {
      // let seat = {
      //   areaname,
      //   seatname,
      //   price,
      //   currency,
      //   clicked,
      // };
      // if (that.seatsSelectedObj[seat.seatname]) {
      //   that.seatsSelectedObj[seat.seatname].clicked = _obj.clicked;
      // } else {
      //   that.seatsSelectedObj[seat.seatname] = {
      //     areaname: seat.areaname,
      //     seatname: seat.seatname,
      //     price: seat.price,
      //     currency: seat.currency,
      //     clicked: _obj.clicked,
      //   };
      // }
    },
    reset(e) {
      let that = this;
      that.scale = 0.9;
      setTimeout(() => that.panzoom.pan(that.resetx, that.resety));
      that.panzoom.zoom(that.scale);
      that.updated();
    },
    areaclicked(e, aindex) {
      //seatJson
      console.log("i am clicked :>> ", e, aindex);
      var self = this;
      this.counter++;
      // console.log("this.$isMobile() :>> ", this.$isMobile());
      if (this.counter == 1 && !isMobile) {
        this.timer = setTimeout(function() {
          // DO NOTHING BUT RESET IN CASE THERES JUST ONE CLICK
          self.counter = 0;
        }, 500); // increase delay as you like
      } else {
        console.log("e :>> ", e);
        if (this.scale < 3) {
          console.log("panzoom.zoomOptions() :>> ", this.scale);
          if (this.scale < 1) {
            this.scale = 1;
            this.panzoom.zoomToPoint(this.scale, e, {
              animate: true
            });
          } else {
            this.scale += 0.2;
            this.panzoom.zoomToPoint(this.scale, e, {
              animate: true
              // step: 0.01,
            });
          }
          this.updated();
          this.seatJson.map((d, index) => {
            if (d.name == "area" && index != aindex) {
              $("#area" + index).css("opacity", 0);
            } else {
              $("#area" + index).css("opacity", 1);
            }
          });
          console.log("object :>> ", this.seatJson.length);
        }
      }
    },
    updated() {
      console.log("scale :>> ", this.scale);
      const that = this;

      if (this.scale < 1) {
        let i = 0;
        $("#panzoom-element .seat-area").each(function() {
          clearInterval(this.int1);
          console.log("object :>> ", $(this).height());
          $(this).css("background-color", that.color[i]);
          // $(this).css("height", $(this).height());
          $(this)
            .find(".seat-area-rows")
            .hide();
          $(this)
            .find(".seat-area-desc")
            .show();
          $(this)
            .find(".seat-area-desc1")
            .hide();
          i++;
        });

        this.seatJson.map((d, index) => {
          if (d.name == "area") {
            $("#area" + index).css("opacity", 1);
          }
        });
      } else {
        let i = 0;
        $("#panzoom-element .seat-area").each(function() {
          clearInterval(this.int1);
          console.log("object :>> ", $(this).height());
          $(this).css("background-color", "transparent");
          // $(this).css("height", $(this).height());
          $(this)
            .find(".seat-area-rows")
            .show();
          $(this)
            .find(".seat-area-desc")
            .hide();
          $(this)
            .find(".seat-area-desc1")
            .show();
          i++;
        });
      }
    },
    activateClick() {
      if (this.int1) {
        let that = this;
        clearInterval(this.int1);
        this.int1 = null;
        $(".seat-row-seat").click(function() {
          console.log("In>>>");
          $(this).toggleClass("seat-selected");
        });
        $(".seat-area").dblclick(function(e) {
          if (that.scale < 1) {
            console.log("panzoom.zoomOptions() :>> ", panzoom);
            that.scale += 0.2;
            that.panzoom.zoomToPoint(that.scale, e, {
              animate: true,
              step: 0.01
            });
            that.updated();
          }
        });
      }
    },

    seatStage() {
      const elem = document.getElementById("panzoom-element");
      this.panzoom = window.Panzoom(elem, {
        minScale: 0.4,
        maxScale: 2,
        animate: true,
        cursor: "default",
        step: 0.1,
        scale: 0
      });
      console.log("object :>> ", this.panzoom);
      let h1 = $("#panzoom-element").height();
      let h2 = $(".section-seatlayout").height();
      let w1 = this.maxSeat * 25;
      let w2 = $(".section-seatlayout").width();
      $(".seat-selection").css("width", this.maxSeat * 25 + "px");
      let that = this;
      this.resetx = (w2 - w1) * 0.5;
      this.resety = (h2 - h1) * 0.5;

      console.log("object h2 :>> ", h2, h1, (h2 - h1) * 0.5);
      this.scale = 0.9;
      setTimeout(() => that.panzoom.pan((w2 - w1) * 0.5, (h2 - h1) * 0.5));
      this.panzoom.zoom(this.scale);
      // let scale = 0.5;
      const parent = elem.parentElement;
      document.addEventListener("touchmove", function(event) {
        console.log("that.scale :>> ", that.scale);
      });
      parent.addEventListener("gestureend", function(e) {
        console.log("that.scale :>> ", that.scale);
        that.scale = that.panzoom.getScale();
        that.panzoom.zoomWithWheel(e, {});
        that.updated();
      });
      parent.addEventListener("wheel", function(e) {
        console.log("that.scale :>> ", that.scale);
        that.scale = that.panzoom.getScale();
        that.panzoom.zoomWithWheel(e, {});
        that.updated();
      });
      this.updated();
      setTimeout(() => {
        $("#panzoom-element").css("visibility", "visible");
        that.hideLoading();
      }, 1000);
    },

    routePaymentPage() {
      this.showLoading();
      console.log(
        "this.getSelectedSeats.length11111",
        this.seat_details.length
      );
      console.log("first", this.seat_details);
      if (this.seat_details.length == 0) {
        this.$toasted.show("Please Select Seats");
        setTimeout(() => {
          this.$toasted.clear();
        }, 5000);
        this.hideLoading();
      } else {
        let country = CountryService.getCountry();
        let data1 = {
          seat_ids: this.seat_details,
          CountryID: country.CountryID
        };
        const { scheduleID } = this.$route.params;
        makeRequest(
          "/v1/event/eventreserve/" + scheduleID,
          "POST",
          null,
          data1,
          this.url,
          false
        )
          .then(response => {
            const { error, res } = response;
            this.hideLoading();
            if (error || res.error) {
              console.log("Response Error ");
              this.$toasted.show(res.error.message);
              setTimeout(() => {
                this.$toasted.clear();
              }, 5000);
            } else {
              this.$router.push({
                path: "/payment-summary/" + res.data.data.event_reserve_id
              });
              this.hideLoading();
            }
          })
          .catch(error => {
            this.hideLoading();
            // console.log("Error", error);
          });
        // this.$router.push({
        //   path: "/payment-summary",
        //   params: {
        //     props: { event_reserve_id: this.getSelectedSeats },
        //   },
        // });
      }
      // this.hideLoading();
    }
  },
  mounted() {
    let that = this;
    this.showLoading();
    const { scheduleID } = this.$route.params;
    makeRequest(
      "/v1/event/getseatlayout/" + scheduleID,
      "POST",
      null,
      null,
      this.url
    ).then(response => {
      const { error, res } = response;
      if (!error) {
        // this.hideLoading();
        // console.log("object :>> ", res.data.data);
        let keys = res.data.order;
        let temp = [];
        let seatTitlesTemp = [];
        let maxcount = 0;
        keys.map(d => {
          let area = res.data.data[d];

          console.log(area, "area");
          let min = 0;

          let rows = [];
          this.wholeData.push(area);
          temp.push(res.data.data[d].seat_type[0]);
          seatTitlesTemp.push(res.data.data[d].title);
          console.log(
            "res.data.data[d].seat_type[0] ",
            res.data.data[d].seat_type[0]
          );
          let diff = 0;
          let pxx = 0;
          let count = 0;
          res.data.data[d].rows.map(d1 => {
            count++;
            console.log("d1 :>> ", d1);
            if (pxx == 0) {
              pxx = Math.abs(d1.px);
            }
            if (Math.abs(d1.py) > min) {
              min = Math.abs(d1.py);
            }

            if (parseFloat(d1.px) < this.pxn) {
              this.pxn = parseFloat(d1.px);
            }
            d1.pxx1 = pxx + parseInt(d1.px);
            // console.log("d1 object :>> ", pxx + Math.abs(d1.px));
            if (!rows[d1.r]) {
              rows[d1.r] = [d1];
            } else {
              rows[d1.r].push(d1);
            }
          });

          if (count > maxcount) {
            maxcount = count;
          }
          area.min = min;
          area.rows = rows;
          this.seatJson.push(area);
        });

        //Remove if premium neede for below event
        // if (res.data.title.includes("Little Mermaid Junior")) {
        //   let removeLittleMadridPremium = this.seatJson.filter(p => {
        //     return p.title != "Premium";
        //   });

        //   if (removeLittleMadridPremium.length > 0) {
        //     this.seatJson = removeLittleMadridPremium;
        //   }

        //   let removeWholeDataLittle = this.wholeData.filter(y => {
        //     return y.title != "Premium";
        //   });

        //   if (removeWholeDataLittle.length > 0) {
        //     this.wholeData = removeWholeDataLittle;
        //   }
        // }

        console.log(this.seatJson, "this.seatJson");
        console.log("d1 min :>> ", maxcount, this.pxn);

        this.maxSeat = Math.round((Math.abs(this.pxn) * 2) / 25);
        if (res.data.stage.index == 0) {
          this.seatJson.unshift(res.data.stage);
          // seatTitlesTemp.unshift("");
        } else {
          this.seatJson.push(res.data.stage);
        }
        this.prices = temp;
        this.seatTitles = seatTitlesTemp;
        console.log("object :>> ", this.prices);
        this.showtitle = res.data.title;
        this.showdatetime = res.data.ShowDateTime;
        this.loading = false;
        this.pxn = Math.abs(this.pxn);
        setTimeout(function() {
          that.seatStage();
        }, 1000);
      }
    });
  }
};
</script>
<style scoped>
.spacing {
  height: 120px;
}

body {
  background: #f5fcff;
  color: #333666;
}

section {
}

.panzoom-parent {
  border: 2px solid #333;
}

.panzoom-parent .panzoom {
  border: 2px dashed #666;
}

.buttons {
  margin: 40px 0 0;
}

.box {
  width: 100px;
  height: 50px;
  margin-top: 20px;
}

.green {
  background-color: green;
}

.red {
  background-color: red;
}

.parent {
  background-color: white;
  border-radius: 20px;
}

.seat-area {
  margin-bottom: 20px;
  position: relative;
}

.seat-area-rows {
  display: flex;
  flex-wrap: nowrap;
  position: absolute;
  /* background-color: DodgerBlue; */
}

.seat-area-desc1 {
  position: absolute;
  width: 100%;
  top: -58px;
}

.seat-row-seat {
  height: 25px;
  width: 25px;
  line-height: 25px;
  background-color: white;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  margin-top: 10px;
  float: left;
  text-align: center;
  font-size: 10px;
  padding: 0 10px;
  color: black;
  display: flex;
  justify-content: center;
  /* position: relative; */
  position: absolute;
}

.seat-area-desc {
  text-align: center;
}

.seat-stage {
  height: 50px;
  background-color: #b1b1b1;
  width: 100%;
}

.seat-selected {
  background-color: var(--pink);
  color: white;
}

.seat-disabled {
  background-color: #d3d3d3;
  color: white;
}

.seat-blocked {
  background-color: #d3d3d3;
  color: white;
}

.seat-booked {
  background-color: grey;
  color: white;
}
#panzoom-element {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/event_seat_layout.vue